export default __webpack_public_path__ + "static/media/tour-1.18984dd6.svg";